import { useCallback, useState } from "react";
export function useImageLoadError(uri) {
  const [erroredUri, setErroredUri] = useState();
  const [prevUri, setPrevUri] = useState(uri);
  if (uri !== prevUri) {
    setPrevUri(uri);
    setErroredUri(void 0);
  }
  const markErrored = useCallback(() => setErroredUri(uri), [uri]);
  return { hasError: uri !== void 0 && erroredUri === uri, markErrored };
}
